<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>      
      <v-flex xs12 sm8 md4>        
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn icon large target="_blank" slot="activator">
                <v-icon large>lock</v-icon>
              </v-btn>
              <span>Registro de nuevo usuario</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <div class="errorAlert" v-if="error">
              {{errorMsg}}
            </div>
            <v-form ref="form" @keyup.native.enter="login">
              <v-text-field
                color="secondary"
                v-model="usuario"
                prepend-icon="person"
                name="login"
                label="Usuario"
                type="text"
                @keydown="error=false"
                @click="error=false"
              ></v-text-field>
              <v-text-field
                color="secondary"
                v-model="contraseña"
                prepend-icon="lock"
                name="password"
                label="Contraseña"
                id="password"
                type="password"
                @keydown="error=false"
                @click="error=false"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="login" color="primary">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    contraseña: "",
   // usuario: ""
  }),
  methods: {
    login() {      
      this.$store.commit('showGlobalLoader');
      this.$store.state.activeAxiosComms.login = true;
      var url = this.ApiBaseUrlNETCore + "api/login/";
      var auxthis = this;
      this.axios
        //.get(this.ApiBaseUrl + "login/" + this.usuario + '/' + this.contraseña)   //Slim             
        .post(url, {user : this.usuario, pass : this.contraseña },{headers: {"Content-Type": "application/json"}}) //API
        .then(response => {          
          this.$store.commit('loginUser', response.data[0]);  //API
          this.getAppConfig();
          //this.$store.commit('loginUser', response.data);   //Slim
          if (this.$store.state.usuarioLogeado)
            this.$router.push('menu');  
        })
        .catch(function (error) {   
            auxthis.error = true;
            auxthis.errorMsg = 'Error en el inicio de sesión';             
            // handle error
            console.log(error);
        })
        .finally(function () {
            auxthis.$store.state.activeAxiosComms.login = false;
            auxthis.$store.commit('hideGlobalLoader');    
        });
    },
    validate() {
      /*this.$router.push("menu");
      if (this.$refs.form.validate()) {
        this.$router.push("menu");
      }*/
    }
  },
  computed: {
    usuario: {
      get() {
        return this.$store.state.usuario.id;
      },
      set(value) {
        this.$store.commit("saveUserId", value);
      }
    },
    error: {
      get() {
        return this.$store.state.loginError;
      },
      set(value) {
        this.$store.state.loginError = value;
      }
    },    
    errorMsg: {
      get() {
        return this.$store.state.loginErrorMsg;
      },
      set(value) {
        this.$store.state.loginErrorMsg = value;
      }
    }
  },
  mounted(){
    if (this.$store.state.usuarioLogeado){
      this.$router.push('menu');
    }
  }
};
</script>

<style scoped>
.errorAlert{  
  position: absolute;
  right: 10px;
  color: red;
  font-weight: 700;
}
</style>
